'use client'

import { useAuth } from '@/contexts/auth-context'
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { getImageUrl } from '@/lib/utils'

export function UserNav() {
  const { user, logout } = useAuth()

  if (!user) return null

  const getAccessLevelLabel = (level: string) => {
    switch (level) {
      case 'admin': return 'Администратор';
      case 'hr': return 'HR';
      case 'project-manager': return 'Менеджер проектов';
      case 'department-head': return 'РО';
      case 'implementation-head': return 'РО реализации';
      case 'senior-engineer': return 'РП';
      case 'engineer': return 'Исполнитель';
      default: return level;
    }
  };

  // Получаем полный URL фотографии из LDAP, если она есть
  const photoUrl = getImageUrl(user.photoUrl);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Avatar className="h-8 w-8 cursor-pointer">
          {photoUrl && (
            <AvatarImage 
              src={photoUrl} 
              alt={user.name}
              onError={(e) => {
                // Скрываем изображение при ошибке загрузки
                e.currentTarget.style.display = 'none';
              }}
            />
          )}
          <AvatarFallback className="text-xs">
            {user.name.split(' ').map(n => n[0]).join('')}
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">{user.name}</p>
            <p className="text-xs leading-none text-muted-foreground">
              {user.email}
            </p>
            <p className="text-xs leading-none text-muted-foreground mt-1">
              {getAccessLevelLabel(user.accessLevel)}
            </p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {user.accessLevel === 'admin' && (
          <>
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={() => window.location.href = '/admin'}
            >
              Администрирование
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="cursor-pointer"
              onClick={() => window.location.href = '/approval'}
            >
              Подтверждения
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuItem
          className="text-red-600 cursor-pointer"
          onClick={logout}
        >
          Выйти
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
} 